/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Default_ViewInputs */



/**
* | output |
* | --- |
* | "Default view" |
*
* @param {Settings_Default_ViewInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_default_view = /** @type {((inputs?: Settings_Default_ViewInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Default_ViewInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Standaardweergave")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue par défaut")
	return /** @type {LocalizedString} */ ("Default view")
});